export default class CompanyList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}

		// Build tax number prefix index
		this.taxnum_index = {}
		for (let entry of this.data) {
			this.taxnum_index[entry.tax_number_prefix] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/company')

		return new CompanyList(data)
	}

	getById (id) {
		return this.index[id]
	}

	getByTaxNumberPrefix (prefix) {
		return this.taxnum_index[prefix]
	}
}
